<template>
  <nuttrema-layout-content>
    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :edit.sync="edit"
        :showEdit="showEdit"
        :StuffToEatDetails="StuffToEatDetails">
      </stuff-to-eat-standard-header>

      <nuttrema-layout-content-header theme="sub-header">
        <permissions-control-wrapper
           slot="left"
           action="label.use_step_by_step_instructions"
          :required-general="$PERMISSIONS_GENERAL.EDIT"
          :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.STEP_BY_STEP_INSTRUCTIONS"
          :permissions="_get(StuffToEatDetails, 'meta.permissions')">

          <nuttrema-group-and-sort slot="allowed" class="is-horizontal">
            <h4 slot="label" class="lbl">{{ $t('label.use_step_by_step_instructions') }}</h4>
            <el-switch v-model="stepByStep" slot="content" @change="changeInstructionMode"></el-switch>
          </nuttrema-group-and-sort>

          <nuttrema-group-and-sort slot="not-allowed" class="is-horizontal">
            <h4 class="lbl" slot="label">{{ $t('label.use_step_by_step_instructions') }}</h4>
            <template slot="content">
              <el-switch v-model="stepByStep" :disabled="true"></el-switch>
            </template>
          </nuttrema-group-and-sort>
        </permissions-control-wrapper>

        <permissions-control-wrapper
           slot="right"
           v-if="stepByStep"
          :clarification="false"
          :required-general="$PERMISSIONS_GENERAL.EDIT"
          :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.STEP_BY_STEP_INSTRUCTIONS"
          :permissions="_get(StuffToEatDetails, 'meta.permissions')">
          <div class="content-header-item" slot="not-allowed">
            <el-button size="small" type="nuttrema-orange" @click="changeInstructionMode(false)">{{ $t('label.turn_off') }}</el-button>
          </div>
        </permissions-control-wrapper>
      </nuttrema-layout-content-header>
    </template>

    <form-stuff-to-eat-simple-instructions
       v-if="!stepByStep"
       slot="central"
      :id="id"
      :edit.sync="edit"
      :productType="productType"
      :StuffToEatDetails="StuffToEatDetails"
      @submit="onFormSubmit">
    </form-stuff-to-eat-simple-instructions>

    <template v-else>
      <nuttrema-loader v-if="StuffToEatInstructions.fetching"></nuttrema-loader>
      <instructions-list
         v-else
         slot="central"
        :meta="meta"
        :edit="edit"
        :StuffToEatInstructions="StuffToEatInstructions"
        @reorder="handleUpdateSequence">
      </instructions-list>
    </template>


    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';
import { get, isEmpty } from 'lodash';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import InstructionsList from './cmpt-instructions-list';
import FormStuffToEatSimpleInstructions from './form-stuff-to-eat-simple-instructions';

export default {
  name: 'page-stuff-to-eat-instructions',
  mixins: [PageProps],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    productType: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLoader,
    InstructionsList,
    NuttremaGroupAndSort,
    NuttremaLayoutContent,
    StuffToEatInfoSmallCard,
    StuffToEatStandardHeader,
    NuttremaLayoutContentHeader,
    FormStuffToEatSimpleInstructions,
  },
  data() {
    return {
      stepByStep: false,
      activeView: 'instructions-simple',
      reorder: false,
      edit: false,
    };
  },
  methods: {
    ...mapActions([
      'SaveStuffToEatDetails',
      'StuffToEatInstructionsUpdateSequence',
    ]),
    changeActiveView() {},
    changeInstructionMode(value) {
      this.SaveStuffToEatDetails({ id: this.id, type: this.productType, payload: { sbs_instructions: value } })
      .catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
    handleUpdateSequence(payload) {
      this.StuffToEatInstructionsUpdateSequence({ id: this.id, type: this.productType, payload })
      .catch((error) => {
        console.error(error);
        this.successNotification();
      });
    },
    onFormSubmit(payload) {
      this.SaveStuffToEatDetails({ id: this.id, type: this.productType, payload }).then(() => {
        this.successNotification({ label: 'label.instructions' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatInstructions() {
      return this.$store.getters.StuffToEatInstructions(this.id);
    },
    showEdit() {
      return this.stepByStep ? !isEmpty(this.StuffToEatInstructions.data) : true;
    },
  },
  created() {
    this.stepByStep = get(this.StuffToEatDetails, 'data.sbs_instructions', false);
    this.$store.dispatch('GetStuffToEatInstructions', { id: this.id, type: this.productType });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatInstructions', { id: this.id });
  },
};
</script>

<style lang="scss" scoped>
  .participant-assigned-programs {
    display: flex;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/instructions/page-stuff-to-eat-instructions.vue